import { render } from "./ErrorMessage.vue?vue&type=template&id=2baeafe6&scoped=true&ts=true"
import script from "./ErrorMessage.vue?vue&type=script&lang=ts"
export * from "./ErrorMessage.vue?vue&type=script&lang=ts"

import "./ErrorMessage.vue?vue&type=style&index=0&id=2baeafe6&scoped=true&lang=scss"

import exportComponent from "/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2baeafe6"]])

export default __exports__